import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("Friend in Christ!");

  useEffect(() => {
    const storedName = localStorage.getItem("student_name");

    if (storedName && storedName.trim()) {
      const firstName = storedName.trim().split(" ")[0];
      setStudentName(firstName || "Friend in Christ!");
    }
  }, []);

  const handleAskClick = () => {
    navigate("/QuestionPage");
  };

  return (
    <>
      <header className="hide_for_confirmation_page">
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>
      <header className="hide_for_media_query">
        <div className="media_query_banner media_query_banner1 ">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo media_query_logo1"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </header>
      <footer>
        <div className="homebody">
          <div className="confirmation">
            <p>
              Welcome to Life Discussion, <b>{studentName}!</b>
            </p>

            <p className="confirmation1a">
              We're so glad you're here — may this session bless and inspire
              you.
            </p>
          </div>
          <div className="check">
            <img src="check.png" alt="Generated QR" />
          </div>
          <div className="confirmation1">
            <p>Got a question or need help?</p>
          </div>
          <button className="homebody2 qrbody" onClick={handleAskClick}>
            <h5>Ask Us</h5>
          </button>
        </div>
      </footer>
    </>
  );
};

export default ConfirmationPage;
